import { ACTION_STATUS } from "../actionbar-detail.constant";
import { ButtonBase } from "./button.base";

export class DownloadButtonModel extends ButtonBase {
    label: string = 'Download';
    action: string = ACTION_STATUS.download;
    matIconName: string = 'download';
    colorClass: string = 'color-info-500';
}